import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropdownComponent } from './dropdown.component';
import { OrderModule } from 'ngx-order-pipe';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, OrderModule, TranslateModule],
  declarations: [DropdownComponent],
  exports: [DropdownComponent],
})
export class DropdownModule {}
